let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1LdrH")).then(() => parcelRequire('4MxBd'));